import { YEAR_DIFF } from './consts';

export const getYearList = (options?: { diff?: number; startYear?: number }) => {
  const { diff = YEAR_DIFF, startYear = new Date(Date.now()).getFullYear() } = options || {};
  const yearList: number[] = [];

  for (let index = startYear; index > startYear - diff; index--) {
    yearList.unshift(index);
  }

  return yearList;
};
